import './ReportShelf.scss';

import { Button } from '@trackman/web-shared-components';
import { ChartType } from 'types/CodegenReportTypes';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type Props = {
  children: React.ReactNode;
  onGenerate: () => void;
  onModify: () => void;
  isLoadingReport: boolean;
  disableGenerate: boolean;
  editingChart: ChartType | undefined;
  setEditingChart: (chart: ChartType | undefined) => void;
  isEditMode: boolean;
};

const ReportShelf = ({
  children,
  onGenerate,
  onModify,
  isLoadingReport,
  disableGenerate,
  editingChart,
  setEditingChart,
  isEditMode,
}: Props) => {
  const { t } = useTranslation();
  const { isCreate } = useReportId();

  return (
    <div className='ReportShelf-container'>
      {children}
      <div className='ReportShelf-buttons'>
        {(!isEditMode || editingChart) && (
          <Button
            key='apply-button'
            label={editingChart ? t('Done') : isCreate ? t('Generate') : t('Apply')}
            intent='primary'
            onClick={editingChart ? () => setEditingChart(undefined) : isCreate ? onGenerate : onModify}
            style={{ width: '100%' }}
            disabled={editingChart ? false : isCreate ? disableGenerate : isLoadingReport}
            isLoading={editingChart ? false : isLoadingReport}
          />
        )}
      </div>
    </div>
  );
};

export default ReportShelf;
